import ProductPlan from "../ProductPlan";
import { en, nl } from "chartjs-graph/translations/product-plans/parking";

export default new ProductPlan({ en, nl });
